import React from 'react';

import { ARROW_LEFT_ICON } from '../../../../constants/images';
import { useScrollState } from '../../../../hooks/useScrollState/useScrollState';
import { ISecondaryHero } from '../../../../interfaces/hero';
import BdsIconButton from '../../Buttons/BdsIconButton/BdsIconButton';

import './SecondaryHero.scss';

const SecondaryHero = ({ title, description, color, bottomContent, backAction }: ISecondaryHero) => {
  const isScrolled = useScrollState(0);

  const heroHeight = isScrolled ? 80 : 245;

  return (
    <>
      <div
        className={`main-hero secondary-hero ${color} ${isScrolled ? 'collapsed' : ''}`}
        style={{ height: heroHeight }}
      >
        <div className="content">
          <div className="back-button">
            <BdsIconButton action={backAction} size="sm" icon={ARROW_LEFT_ICON} variant="transparent" />
            <div className="title">{title}</div>
          </div>

          <div className="description">{description}</div>
        </div>
        <div className="bottom-content">{bottomContent}</div>
      </div>
      <div style={{ height: heroHeight }} />
    </>
  );
};

export default SecondaryHero;
